// @flow

import React from 'react'
import bindViewModel from '@vimcar/shared-utils/bindViewModel'
import RadioButtonGroup from '@vimcar/shared-components/components/RadioButtonGroup'

import Err from '#components/Err'
import styles from '../../styles.css'
import mkViewModel from './viewModel'
import i18n from '#utils/i18n'

type Props = {|
  className: string,
  disabled: boolean,
  titleClassName: string,
|}

const tp = i18n.prefix('components.TimezonePreferences')

export default bindViewModel<_, Props>(
  (vm, { disabled, className, titleClassName }) => (
    <section className={className}>
      <h3 className={titleClassName}>
        {tp('default-timezone')}
      </h3>
      <RadioButtonGroup
        className={styles.radioGroup}
        name='default-timezone'
        onChange={vm.handleTimezoneChange}
        valueSelected={vm.currentTimezone}
        >
        {vm.timezoneOptions.map(({ zone, label }) => (
          <RadioButtonGroup.RadioButton
            disabled={disabled || vm.updateZoneinfo$.isPending}
            key={zone}
            label={label}
            value={zone}
            />
        ))}
      </RadioButtonGroup>
      {vm.updateZoneinfo$.isFailed && (
        <Err>{tp('update-error')}</Err>
      )}
    </section>
  ),
  mkViewModel,
  { displayName: 'TimezonePreferences' },
)
